// auth.js
import axios from 'axios';
import { AppConfig } from "@/constants";
import { jwtDecode } from "jwt-decode";

// const apiClient = axios.create({
//   baseURL: AppConfig.API_BASE_URL + '/user', // Replace with your actual API base URL
//   timeout: 6000, // Request timeout in milliseconds
//   headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('access_token') },
// });

export async function isAuthenticated() {
  let response = {};
  let token = localStorage.getItem('access_token');
  try {
    response = await axios.get(AppConfig.API_BASE_URL + '/user/validateToken', {headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }});
    if (response.status == 200){
      response.authenticated = true;
      const decoded = jwtDecode(token);
      response.user = decoded;
      return response;
    }else{
      localStorage.removeItem('access_token');
      response.authenticated = false;
      return response;
    }
  } catch (error) {
    console.error('Authentication check failed:', error);
    localStorage.removeItem('access_token');
    response.authenticated = false;
    return response;
  }
}
